import { IdentifierRecord } from './Utils'
import { Chapter, ChapterWithGem } from './Chapter'

export enum CourseSubType {
  COURSE = 'course',
  SERIES = 'series',
  CAMP = 'camp',
}

export interface Sample {
  brightcoveVideoId?: string
  mediaUuid?: string
}

/**
 * @deprecated use a course type from `@mc/api` instead.
 */
export interface Course {
  brightcoveVideoId?: string | null
  mediaUuid?: string
  categories?: Category[] | null
  categoriesLabel?: string | null
  cinematic12x5?: string | null
  displaySubtitle?: string | null
  displayTitle?: string | null
  headline?: string | null
  id: string | number
  image16x9?: string | null
  image4x3?: string | null
  image2x3?: string | null
  instructorBio?: string | null
  instructorName?: string | null
  instructorTagline?: string | null
  isMultiInstructor?: boolean | null
  multiInstructorName?: null | string
  marketingCmColumn?: string | null
  marketingOverview?: string | null
  nameplate?: string | null
  numChapters?: number | null
  overview?: string | null
  primary1x1?: string | null
  primary2x3?: string | null
  primary16x9?: string | null
  primaryCategory?: IdentifierRecord<null> | null
  sample?: Sample | null
  skill?: string | null
  slug?: string | null
  sortedChapters?: ChapterWithGem[] | null
  upcomingChapters?: ChapterWithGem[] | null
  title?: string | null
  type: 'course' | 'series' | 'camp'
  shortOverview?: string | null
  releaseDescription?: string
  tag?: string | null
  upcomingChapter?: Chapter
  uuid?: string
  totalSeconds?: number | null
  marketingPrelaunchStartsAt?: string
  marketingPostlaunchEndsAt?: string
  subchapters?: ChapterWithGem[] | null
  sortedSubchapters?: ChapterWithGem[] | null
}

type Category = {
  camps?: IdentifierRecord[] | null
  courses?: IdentifierRecord[] | null
  id?: number | null
  name?: string | null
  slug?: string | null
}
